import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import { startLoadingSpinner, stopLoadingSpinner } from '../../csf-ufc-pivotal/includes/utils';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import CsfFournisseurFormationsList from "./csf-fournisseur-formations-list";
import CsfFournisseurHomeMenu from "./csf-fournisseur-home-menu";
import { handleClickLinks } from "../includes/utils";
import PropTypes from "prop-types";
import { CsfPivotalFournisseurEventRecognition } from "./csf-fournisseur-event-recognition";
import { CsfPivotalFournisseurEventModification } from "./csf-fournisseur-event-modification";
import { CsfPivotalFournisseurRecognitionRenewal } from "./csf-fournisseur-recognition-renewal";

export function CsfPivotalFournisseurHome({ apiUrl, apiEnv, urlDetailFormation, urlList, urlGestion, urlDelegation, urlRequestRecognition }) {

  const [accessToken, setAccessToken] = useState('');
  const [formations, setFormations] = useState([]);
  const [role, setRole] = useState(1);
  const [passwordChangedSuccess, setPasswordChangedSuccess] = useState(false);

  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    startLoadingSpinner();
    fetchAccessToken();
    const passwordChanged = localStorage.getItem("fournisseur_passwordchanged");
    if (passwordChanged && passwordChanged === '1') {
      localStorage.removeItem("fournisseur_passwordchanged");
      setPasswordChangedSuccess(true);
    }
  }, []);

  /*
  * When the accessToken is fetched and state is updates, get the formations lists.
  * */
  useEffect(() => {
    if (accessToken) {
      getFormationsList();
    }
  }, [accessToken]);

  /*
  * Init the bootstrap tooltips on list change
  * */
  useEffect(() => {
    if (formations) {
      $('[data-toggle="tooltip"]').tooltip({
        customClass: 'sup-tooltip'
      });
    }
  }, [formations]);
  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('fournisseur')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
          setRole(response.api_role);
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to fetch the formations lists of the users.
  * */
  function getFormationsList() {
    const requestData = buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setFormations(response.payload.data.rows);
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to build the body array for the request
  * */
  function buildMainBodyDataResquest() {
    let requestData = {
      maxRows: 4, // get only the last 4 on the homepage
      startRow: 0,
      ParameterValues: [""],
      matchCondition: 1,
      search: 'CSF_EP_Activity_REST',
      searchResultsList: 'CSF_EP_Activity_SRL'
    };

    return requestData;
  }

  return (
    <main className="fournisseur home">
      {passwordChangedSuccess === true && (
        <div className="grid-container-large">
          <div data-drupal-messages="">
            <div role="contentinfo" className="status-message" aria-label="Status message">
              <h2 className="visually-hidden">Status message</h2>
              {window.Drupal.t('fournisseur.password.changed.success.msg')}
            </div>
          </div>
        </div>
      )}

      <div className="content">

        {/* main section */}
        <section className="list primary">

          {/* sub title */}
          <h1 className="h2">{window.Drupal.t('fournisseur.trainings.list.title')}</h1>

          <CsfFournisseurFormationsList
            formations={formations}
            urlDetailFormation={urlDetailFormation}
          />

          {/* see more button */}
          <div className="list-seemore">
            <button onClick={() => handleClickLinks(urlList)} className="button btn-outlined btn-larger">
              {window.Drupal.t('fournisseur.all.training.btn.label')}
            </button>
          </div>

        </section>

        {/* aside section */}
        <CsfFournisseurHomeMenu
          urlGestion={urlGestion}
          urlDelegation={urlDelegation}
          urlRequestRecognition={urlRequestRecognition}
          role={role}
        />

      </div>

      <CsfPivotalFournisseurEventRecognition />
      <CsfPivotalFournisseurEventModification />
      <CsfPivotalFournisseurRecognitionRenewal
        apiUrl={apiUrl}
        apiEnv={apiEnv}
        accessToken={accessToken}
        urlRequestRecognition={urlRequestRecognition}
      />

    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfPivotalFournisseurHome');
  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlGestion = domNode.getAttribute("data-url-gestion");
    const urlDetailFormation = domNode.getAttribute("data-url-detail");
    const urlList = domNode.getAttribute("data-url-list");
    const urlDelegation = domNode.getAttribute("data-url-delegation");
    const urlRequestRecognition = domNode.getAttribute("data-url-request-recognition");

    root.render(<CsfPivotalFournisseurHome
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlGestion={urlGestion}
      urlDetailFormation={urlDetailFormation}
      urlList={urlList}
      urlDelegation={urlDelegation}
      urlRequestRecognition={urlRequestRecognition}
    />);
  }

});

CsfPivotalFournisseurHome.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlDetailFormation: PropTypes.string,
  urlList: PropTypes.string,
  urlGestion: PropTypes.string,
  urlDelegation: PropTypes.string,
  urlRequestRecognition: PropTypes.string,
};
